// Sensor types and constants adapted from monorepo

export interface SensorConfiguration {
  id?: number
  deviceId: number
  sensorNumber: number // 1-7 mapping to A1, A2, B1, B2, C1, C2, C3
  sensorName: string
  sensorProductId?: number
  conversionScale: number // Calibration scale factor
  conversionOffset: number // Calibration offset factor
  unitCategoryId?: number // Unit category ID
  unitId?: number // Specific unit ID
  dateEffect: Date // When this configuration becomes active
}

export interface SensorSetting {
  id?: number
  deviceId: number
  sensorNumber: number
  sensorPosition?: number // Physical depth/position in mm
  warnHigh?: number // High threshold warning
  warnLow?: number // Low threshold warning
  warnChange?: number // Change threshold warning
  warnFlags?: number // Warning configuration flags
  areaValue?: number // Area calculations for flow sensors
  areaEnable: boolean // Enable area-based calculations
  viewFlags: number // Display configuration flags
}

// Port mapping utilities
export const SENSOR_PORTS = {
  1: 'A1',
  2: 'A2',
  3: 'B1',
  4: 'B2',
  5: 'C1',
  6: 'C2',
  7: 'C3',
} as const

export const PORT_NAMES = {
  A1: 1,
  A2: 2,
  B1: 3,
  B2: 4,
  C1: 5,
  C2: 6,
  C3: 7,
} as const

export type SensorPortName = keyof typeof PORT_NAMES
export type SensorPortNumber = keyof typeof SENSOR_PORTS

// Chart line colors for sensor ports
export const SENSOR_PORT_COLORS: Record<SensorPortNumber, string> = {
  1: '#FFA500', // A1 - Orange
  2: '#FF6347', // A2 - Tomato
  3: '#0000FF', // B1 - Blue
  4: '#4169E1', // B2 - Royal Blue
  5: '#FF00FF', // C1 - Magenta
  6: '#8A2BE2', // C2 - Blue Violet
  7: '#32CD32', // C3 - Lime Green
}

// Sensor configuration form data
export interface SensorConfigFormData {
  sensorName: string
  sensorProductId?: number
  sensorPosition?: number
  conversionScale: number
  conversionOffset: number
  unitCategoryId?: number
  unitId?: number
  warnHigh?: number
  warnLow?: number
  warnChange?: number
  alertsEnabled: boolean
}

// Default sensor configuration
export const DEFAULT_SENSOR_CONFIG: Omit<SensorConfiguration, 'deviceId' | 'sensorNumber'> = {
  sensorName: 'Unnamed Sensor',
  conversionScale: 1.0,
  conversionOffset: 0.0,
  dateEffect: new Date(),
}

// Default sensor settings
export const DEFAULT_SENSOR_SETTING: Omit<SensorSetting, 'deviceId' | 'sensorNumber'> = {
  areaEnable: false,
  viewFlags: 0,
}
